import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { Logo } from './Common';
import { ScrollProgress } from './ScrollProgress';

const links = [
  { label: 'Carro 2027', id: 'carro-2027', testId: 'carro-2027' },
  { label: 'La nostra storia', id: 'storia', testId: 'storia' },
  { label: 'Le creazioni', id: 'creazioni', testId: 'creazioni' },
  { label: 'Video', id: 'video', testId: 'video' },
  { label: 'Le vittorie', id: 'vittorie', testId: 'vittorie' },
  { label: 'Merch', to: '/shop', testId: 'merch' },
  { label: 'Fantasti3D', to: '/fantasti3d', testId: 'fantasti3d' },
  { label: 'Social', id: 'social', testId: 'social' },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === '/';
  const sectionHref = (id) => (onHome ? `#${id}` : `/#${id}`);

  useEffect(() => {
    const update = () => setScrolled(window.scrollY > 60);
    update(); window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);
  useEffect(() => {
    const escape = (event) => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', escape);
    return () => document.removeEventListener('keydown', escape);
  }, []);

  const renderLink = (link, mobile = false, index = 0) => {
    const testid = `${mobile ? 'mobile-nav' : 'nav'}-${link.testId}`;
    const content = <>{mobile && <span>0{index + 1}</span>}{link.label}{mobile && <ArrowUpRight />}</>;
    const onClick = mobile ? () => setOpen(false) : undefined;
    if (link.to) return <Link to={link.to} key={link.testId} onClick={onClick} data-testid={testid}>{content}</Link>;
    return <a href={sectionHref(link.id)} key={link.testId} onClick={onClick} data-testid={testid}>{content}</a>;
  };

  return <><ScrollProgress /><header className={`site-header ${scrolled || open ? 'is-scrolled' : ''}`} data-testid="site-header">
    <Logo />
    <nav className="desktop-nav" aria-label="Navigazione principale">{links.map((link) => renderLink(link))}</nav>
    <a className="header-contact" href={sectionHref('scrivici')} data-testid="nav-scrivici">Entra nel nostro mondo <ArrowUpRight size={17} /></a>
    <button className="mobile-toggle" aria-label={open ? 'Chiudi menu' : 'Apri menu'} aria-expanded={open} aria-controls="mobile-menu" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">{open ? <X /> : <Menu />}</button>
    <AnimatePresence>{open && <motion.nav id="mobile-menu" className="mobile-nav" aria-label="Navigazione mobile" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }} data-testid="mobile-navigation">{[...links, { label: 'Scrivici', id: 'scrivici', testId: 'scrivici' }].map((link, i) => renderLink(link, true, i))}</motion.nav>}</AnimatePresence>
  </header></>;
};
